import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';
import AppHeader from './AppHeader';
import WelcomeScreenFigure from '../svg/WelcomeScreenFigure';
import BackIcon from '../svg/BackIcon';
import { Link } from 'react-router-dom';
import { Brands } from '../../../models/brands';

type WelcomeScreenProps = {
    children?: React.ReactNode;
    className?: string;
    isBackIconShown?: boolean;
    isHeaderShown?: boolean;
    brandId?: Brands;
};

const MainContainer: React.FC<WelcomeScreenProps> = ({
    children,
    className,
    isBackIconShown = false,
    isHeaderShown = false,
    brandId = Brands.URocked
}) => {
    return (
        <div className="flex">
            <div className="hidden lg:flex bg-sky-blue w-1/2 items-center justify-center relative">
                <div className="flex flex-col lg:w-[368px] xl:w-[524px] min-h-[100dvh] lg:min-h-min lg:rounded-t-3xl lg:rounded-b-3xl bg-white lg:p-6 z-10 relative xl:p-12">
                    <AppHeader
                        isBackIconShown={false}
                        className="md:bg-white lg:!h-6 md:!p-0 xl:!h-10"
                    ></AppHeader>
                    <div className="lg:pt-4 xl:pt-8 lg:pb-6 xl:pb-12">
                        <h6 className="mx-3 text-center transition duration-200 text-pressed-blue font-medium md:text-2xl xl:text-4xl">
                            Send a tip!
                        </h6>

                        <p className="lg:mt-3 xl:mt-6 text-center text-pressed-blue xl:text-lg">
                            A quick, secure, and cashless way to say “thank you”
                            to the people who made your day better. Small
                            action, big appreciation.
                        </p>
                    </div>
                </div>
                <WelcomeScreenFigure className="absolute right-0 bottom-0 lg:w-[508px] lg:h-[440px] xl:w-[960px] xl:h-[635px]" />
            </div>
            <div className="md:background-3 w-screen bg-background-3 h-[100dvh] md:flex md:items-center md:justify-center lg:w-1/2 relative">
                {isBackIconShown && (
                    <div className="absolute left-0 top-0 hidden lg:flex xl:p-2">
                        <Link to={'/'}>
                            <BackIcon className="ml-5 mr-5 mt-4 mb-4" />
                        </Link>
                    </div>
                )}
                <div
                    className={`flex flex-col overflow-hidden md:rounded-t-3xl md:rounded-b-3xl 
                md:bg-white md:p-6 xl:p-10 h-[100dvh] md:h-auto md:min-h-[658px] lg:min-h-[586px] md:w-[406px] lg:w-[374px] xl:w-[438px] ${className}`}
                >
                    {isHeaderShown && (
                        <AppHeader
                            isBackIconShown={true}
                            className="lg:hidden md:mb-0 md:!p-0 md:!h-10"
                            brandId={brandId}
                        ></AppHeader>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainContainer;
